
import { FETCH_RESERV_REQUEST, FETCH_RESERV_SUCCESS, FETCH_RESERV_FAILURE } from './actionsTypes';

export const fetchReservRequest = (token,history) => ({
  type: FETCH_RESERV_REQUEST,
  payload: { token,history },
});

export const fetchReservSuccess = (reservData) => ({
  type: FETCH_RESERV_SUCCESS,
  payload: { reservData },
});

export const fetchReservFailure = (error) => ({
  type: FETCH_RESERV_FAILURE,
  payload: { error },
});

